import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { WEEKDAYS, WEEKDAY_COLORS, getVisitsForDateAndAssignee } from "./reportHelpers";

export const SiteScheduleReport = ({ weekDates, weekTitle, activeUsers, sites, visits, users, onSiteGroupClick }) => (
  <Card className="border-0 shadow-lg mb-8" data-testid="site-schedule-report">
    <CardHeader><CardTitle className="text-xl font-bold text-gray-900 mb-4">{weekTitle}</CardTitle></CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white">
              <th className="border border-gray-300 p-3 text-left font-medium w-40">Coordinator</th>
              {weekDates.map((date, i) => (
                <th key={`coord-${date.toISOString()}`} className="border border-gray-300 p-3 text-center font-medium min-w-52">
                  <div className={`font-bold ${WEEKDAY_COLORS[i]}`}>{WEEKDAYS[i]}</div>
                  <div className="text-sm font-normal">{date.getDate()}-{date.toLocaleDateString('en-US', { month: 'short' })}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {activeUsers.map((user, userIndex) => (
              <tr key={user.id} className={userIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="border border-gray-300 p-3 font-medium text-gray-900">
                  <div className="font-bold text-blue-900">{user.name}</div>
                  <div className="text-xs text-gray-500 mt-1">{user.role}</div>
                </td>
                {weekDates.map((date) => {
                  const userVisits = getVisitsForDateAndAssignee(date, user.name, users, visits);
                  const siteGroups = {};
                  userVisits.forEach(v => {
                    const site = sites.find(s => s.id === v.site_id);
                    const siteName = site?.name || 'Unknown Site';
                    if (!siteGroups[siteName]) siteGroups[siteName] = [];
                    siteGroups[siteName].push(v);
                  });
                  return (
                    <td key={`coord-${user.id}-${date.toISOString()}`} className="border border-gray-300 p-2 align-top">
                      <div className="space-y-2">
                        {Object.entries(siteGroups).map(([siteName, siteVisits]) => {
                          const visitTypes = [...new Set(siteVisits.map(v => v.visit_type))];
                          const visitCount = siteVisits.length;
                          return (
                            <div
                              key={siteName}
                              className="bg-gradient-to-r from-blue-100 to-cyan-100 border border-blue-200 rounded-lg p-3 cursor-pointer hover:shadow-md transition-shadow"
                              onClick={() => onSiteGroupClick({ site: siteName, date, coordinator: user.name, visits: siteVisits })}
                            >
                              <div className="font-bold text-blue-800 text-sm mb-1">{siteName.length > 20 ? siteName.substring(0, 20) + '...' : siteName}</div>
                              <div className="text-xs text-blue-700 mb-1">{visitCount} visit{visitCount !== 1 ? 's' : ''}</div>
                              <div className="text-xs text-blue-600">{visitTypes.map(t => t?.replace('_', ' ')?.toUpperCase() || 'VISIT').join(', ')}</div>
                            </div>
                          );
                        })}
                        {Object.keys(siteGroups).length === 0 && <div className="text-gray-400 text-xs text-center py-4">No visits</div>}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
